<div class="modal-body">
  <div class="container-fluid">
    <div class="grid-col flex-auto">
        <legend class="usa-legend usa-legend--medium">Profile Update Notes History {{header}}</legend>
        <legend class="usa-legend usa-legend--medium" [innerHTML]="profileName"></legend>
    </div>
  </div>
  <div class="grid-row">
    <ag-grid-angular
      style="width: 100%; height: 400px;"
      class="ag-theme-alpine"
      [gridOptions]="updateMessagesOptions"
      [rowData]="rowData"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [columnDefs]="columnDefs"
      [suppressDragLeaveHidesColumns]="true"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="closeModal()">Close</button>
</div>

